import { ProfileAvatarCard } from "@/components/profile/ProfileAvatarCard";
import { PageHeader } from "@/components/shared/page-header";

export function ProfilePage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Profile" description="Manage your account photo and details." />
      <ProfileAvatarCard />
    </div>
  );
}
